require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-uppingthestakes.json") })
        }
      }, "path---insights-uppingthestakes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-uppingthestakes!./.cache/json/insights-uppingthestakes.json
// module id = 1140
// module chunks = 231608221292675